<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg6 md6 >
        <v-container class="text-center" fluid fill-height style="padding-bottom:213px">
          <v-alert
            :v-model="true"
            dense
            border="left"
            type="error"
            :style="alertError.alert ? 'width:100%;visibility: visible;':'width:100%;visibility: hidden;'"
            class="text-center"
          >{{alertError.message}}</v-alert>

          <div class="text-center" style="width:100%">
            <v-img v-if="$route.name != 'SuccessRecovery' && $route.name != 'ErrorRecovery'" contain height="140" :src="require('@/assets/logo-samu.png')"></v-img>
            <router-view></router-view>
          </div>
        </v-container>
        <div class="text-center d-flex align-center justify-space-around mt-n12" v-if="$route.name != 'SuccessRecovery' && $route.name != 'ErrorRecovery' && $route.name != 'about'">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn STYLE="text-transform: none" color="primary" outlined dark v-bind="attrs" v-on="on" to="/about">Sobre o PREH</v-btn>
            </template>
            <span>Saiba mais sobre este sistema</span>
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex lg6 md6 class="d-none d-md-block" v-if="$route.name != 'SuccessRecovery' && $route.name != 'ErrorRecovery' && $route.name != 'about'">
        <v-img :src="require('@/assets/ambulancias.jpeg')" :height="window.height" width="100%"></v-img>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  data() {
    return {
      mask: { document: "###.###.###-##" },
      document: "",
      email: "",
      password: "",
      window: {
        width: 0,
        height: 0,
      },
      emailRules: [
        (v) => !!v || "Necessário preencher o E-mail!",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail inválido!",
      ],
      passwordRules: [(v) => !!v || "Necessário preencher a senha!"],
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    alertError() {
      return this.$store.getters.alertError;
    },
    disabledButton() {
      return !this.$refs.form.validate();
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    user() {
      console.log("User logged!");
      var value = this.user;
      if (value) {
        if (this.$store.getters.userRule.includes("tarm") || this.$store.getters.userRule.includes("nurse")) {
          this.$router.push("/tarmcalls");
        }
        else if (this.$store.getters.userRule.includes("regulatory-physician")){
          this.$router.push("/doctorcalls");
        }
        else if (this.$store.getters.userRule.includes("admin")) {
          this.$router.push("/userslist");
        }
        else if(this.$store.getters.userRule.includes("fleet-manager")){
          this.$router.push("/FleetManager" );
        } else {
          this.$router.push("/erroraccess");
        }
      }
    },
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>
